import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** 固定資産管理システムでの扱い */
enum TreatmentFixedAssetControl {
  expenseProcessing = '1',
  noExpenseProcessing = '2',
  noExpenseProcessingIFRS = '3',
}

const nameConfig = {
  expenseProcessing: new Map([[Locale.ja, '費用処理する']]),
  noExpenseProcessing: new Map([[Locale.ja, '費用処理しない']]),
  noExpenseProcessingIFRS: new Map([[Locale.ja, 'IFRSのみ費用処理しない']]),
};

// TODO:固定資産管理上での扱いの費用処理する対応が出来たら開放する予定 https://proship-infra.atlassian.net/browse/PSD-362
const toEnum = rawValueToEnum(TreatmentFixedAssetControl, TreatmentFixedAssetControl.noExpenseProcessing);
const toDisplay = enumToName(TreatmentFixedAssetControl, nameConfig);
const toDisplayWithPrefix = enumToName(TreatmentFixedAssetControl, nameConfig, { prefix: true });

export const treatmentFixedAssetControl = {
  enum: TreatmentFixedAssetControl,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { TreatmentFixedAssetControl };
